import Glide from '@glidejs/glide'

/*
 * Kontakt 2026 – pobočky.
 * Vlastní modul (ne offices-glide.js), aby zůstalo nastavení slideru
 * na původní stránce Kontakt nedotčené.
 *
 * Řada jde přes celou šířku okna. Aby první karta lícovala s nadpisem,
 * počítá se peek.before z pozice .js-offices-anchor uvnitř kontejneru
 * a perView se dopočítá tak, aby karta zůstala ~242 px jako ve Figmě.
 */

const CARD_DESKTOP = 242
const CARD_MOBILE = 220
const GAP_DESKTOP = 50
const GAP_MOBILE = 24

const debounce = (func, timeout = 150) => {
    let timer
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => func.apply(this, args), timeout)
    }
}

const initContactOfficesBlock = () => {
    const block = document.querySelector('.js-block-offices-v2')

    if (!block) return
    const gliderRoot = block.querySelector('.glide')
    if (!gliderRoot) return

    const anchor = block.querySelector('.js-offices-anchor')

    const layout = () => {
        const track = gliderRoot.clientWidth || window.innerWidth
        const before = anchor
            ? Math.max(0, Math.round(anchor.getBoundingClientRect().left))
            : 0

        const isMobile = track < 640
        const card = isMobile ? CARD_MOBILE : CARD_DESKTOP
        const gap = isMobile ? GAP_MOBILE : GAP_DESKTOP

        // Glide: slideWidth = (track - peek - gap * (perView - 1)) / perView
        const perView = Math.max(1.1, (track - before + gap) / (card + gap))

        return { perView, gap, peek: { before, after: 0 } }
    }

    const glide = new Glide(gliderRoot, {
        type: 'carousel',
        autoplay: 5000,
        hoverpause: true, // posouvání se zastaví, když je myš nad sliderem
        animationDuration: 800,
        swipeThreshold: 40,
        dragThreshold: 60,
        touchAngle: 30,
        ...layout()
    })

    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted')
    })

    glide.mount()

    /*
     * Adresu je potřeba jít označit myší. Glide jinak každé stisknutí myši
     * vyhodnotí jako začátek přetažení, tak mu na textu událost nepustíme dál.
     * Na dotyku necháváme vše být, aby fungovalo swipování prstem.
     */
    block.querySelectorAll('.js-selectable').forEach((element) => {
        element.addEventListener('mousedown', (event) => event.stopPropagation())
    })

    window.addEventListener('resize', debounce(() => glide.update(layout())))
    window.addEventListener('orientationchange', debounce(() => glide.update(layout())))
}

export { initContactOfficesBlock }
